import moment from 'moment';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';

export enum VerificationStatus {
  None = 'NONE',
  Verified = 'VERIFIED',
  Requested = 'REQUESTED',
  Expired = 'EXPIRED',
}

const GET_POST_VERIFICATION_STATUS_POST_FRAGMENT = gql(`
  # eslint-disable-next-line @graphql-eslint/require-selections
  fragment getVerificationStatus_post on Post {
    verification {
      id
      insertedAt
    }
    verificationEntries {
      id
      expiredAt
    }
  }
`);

export default function getVerificationStatus({
  verification,
  verificationEntries,
}: DocumentType<
  typeof GET_POST_VERIFICATION_STATUS_POST_FRAGMENT
>): VerificationStatus {
  const lastEntry = verificationEntries?.[0];
  const isLastEntryInTheCurrentPeriod =
    verification &&
    lastEntry &&
    (!lastEntry.expiredAt ||
      moment(lastEntry.expiredAt) > moment(verification.insertedAt));

  if (!isLastEntryInTheCurrentPeriod) {
    return verification
      ? VerificationStatus.Requested
      : VerificationStatus.None;
  }

  return lastEntry?.expiredAt
    ? VerificationStatus.Expired
    : VerificationStatus.Verified;
}
